import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBriefcaseLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M14 3C15.6569 3 17 4.34315 17 6H20C21.1046 6 22 6.89543 22 8V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V8C2 6.89543 2.89543 6 4 6H7C7 4.34315 8.34315 3 10 3H14ZM11 12H4V19H20V12H13V13C13 13.5523 12.5523 14 12 14C11.4872 14 11.0645 13.614 11.0067 13.1166L11 13V12ZM20 8H4V10H20V8ZM14 5H10C9.48717 5 9.06449 5.38604 9.00673 5.88338L9 6H15C15 5.48717 14.614 5.06449 14.1166 5.00673L14 5Z" })
});
export default SvgBriefcaseLine;
